import { render } from "./ChatScreen.vue?vue&type=template&id=a5a44d8c&scoped=true"
import script from "./ChatScreen.vue?vue&type=script&lang=js"
export * from "./ChatScreen.vue?vue&type=script&lang=js"

import "./ChatScreen.vue?vue&type=style&index=0&id=a5a44d8c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\darca\\dev\\spanish-ai\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5a44d8c"]])

export default __exports__